import React from 'react';

import ScrollHintWrapper from '../styled/ScrollHintWrapper';
import ScrollHintScrollContainer from '../styled/ScrollHintScrollContainer';

var ContainerNavigationChildren = function ContainerNavigationChildren(_ref) {
  var children = _ref.children,
      hasScrollHintTop = _ref.hasScrollHintTop,
      scrollRef = _ref.scrollRef;
  return React.createElement(
    ScrollHintWrapper,
    { hasScrollHintTop: hasScrollHintTop },
    React.createElement(
      ScrollHintScrollContainer,
      { innerRef: scrollRef },
      children
    )
  );
};
ContainerNavigationChildren.displayName = 'ContainerNavigationChildren';
export default ContainerNavigationChildren;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/ContainerNavigationChildren.js
// module id = 606
// module chunks = 0